import { createClient, dedupExchange, fetchExchange } from 'urql'
import { cacheExchange } from '@urql/exchange-graphcache'

export const client = createClient({
  url: '/api',
  requestPolicy: 'cache-and-network',
  // exchanges: [
  //   dedupExchange,
  //   cacheExchange({
  //     updates: {
  //       Mutation: {
  //         organization: (result, args, cache, info) => {
  //           // if anything regarding orgs is changed - invalidate!
  //           console.log('invalidating')
  //           cache.invalidate('Query', 'user')
  //         },
  //       },
  //     },
  //   }),
  //   fetchExchange,
  // ],
})
